import React from "react";
import "./recommend.scss";
import JobItem from "../JobItem/jobItem";
import { setMLog, shareWB, shareWeiXin } from "../../env/fun.js";
import { requestGet } from "../../env/api.js";
import { Toast } from "../Toast/Toast.js";
function debounce(fn, delay) {
  let timer = null;
  return function () {
    timer && clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
}
export default class Recommend extends React.Component {
  state = {
    tabList: [], //taba列表
    currentIndex: 0, //选中tab
    jobItemList: [], //职位列表
    currentPage: 1,
    isLastPage: false,
    isFlex: false,
    pid:"",
    tagList:{},
    successRequest:true,
    request:this.props.request,
    totalPage:1,//总页数
    totalJobList:[],
  };

  //处理点击tab
  handTagActive = (index) => {
    setMLog('2021magical_guess_switch')
    this.setState({
        currentIndex: index,
    })
    let {tagList}=this.state;
    this.setState({
      currentIndex: index,
      currentPage:1,
      pid:"",
      isLastPage:false,
    },()=>{
      this.requestJobItem(
        tagList[index],
        1
      );
    });
  };

  // 请求职位列表
  requestJobItem = async (tagObj,pageIndex,type) => {
    let { jobItemList,pid} = this.state;
    let {tagid,tagName,tagtype}=tagObj
    let res = await requestGet("recommendJobList", {
      local: window._CITY.dispLocalId,
      tag:{tagId:tagid,tagName,tagType:tagtype},
      page: pageIndex,
      pageSize:150,
      pid:pid
    });
    if (res && res.code === 0) {
      // let lastpage = res.resultEntity.map.lastpage;
      this.setState({
        pid:res.resultEntity.map.pid
      })
      let jobList = res.resultEntity.infolist;
      if(jobList.length===0){
        this.setState({
          isLastPage:true
        })
      }
      let totalPage=Math.ceil(jobList.length/20);
      let newJobItemList = [];
      newJobItemList = jobList.slice(0,21);
        // if (type === "add") {
        //   newJobItemList = [...jobItemList, ...jobList];
        // } else {
        //   // newJobItemList = jobList;
        //   newJobItemList = jobList.slice(0,21);
        // }
        this.setState({
          jobItemList: newJobItemList,
          totalJobList:jobList,
          totalPage:totalPage
        });
    }else{
      this.setState({
        successRequest:false
      })
    }
  };

  //增加职位
  handAddJobItem = () => {
    let { currentPage, currentIndex,tagList ,totalJobList} = this.state;
    let page = currentPage + 1;
    let newJobList =totalJobList.slice(0,20*page)
    this.setState({
      currentPage: page,
      jobItemList:newJobList
    });
    // this.requestJobItem(
    //   tagList[currentIndex],
    //   page,
    //   "add"
    // );
  };

  //请求推荐的导航栏
  requestTjjob = async () => {
    let res;
    let tag=[]
      res = await requestGet("recommendTabList", {
        local:window._CITY.dispLocalId
      });
      if (res && res.code === 0) {
        if(res.resultEntity){
          tag = res.resultEntity.rectagList;
        }else{
          this.setState({
            successRequest:false
          })
        }
        this.setState({
            tagList:[...tag],
        },() => {
            this.setStyle();
        });
        this.requestJobItem(tag[0],1);
      }else{
        this.setState({
          successRequest:false
        })
      }
  };

  setStyle() {
    let navWidth = document.getElementsByClassName("container_nav")[0]
      .offsetWidth;
    let tablistWidth = document.getElementsByClassName("navlist")[0]
      .offsetWidth;

    if (tablistWidth < navWidth) {
      this.setState(
        {
          isFlex: true,
        }
      );
    }
  }

  componentDidMount() {
    window.Top = document.getElementsByClassName("container_box")[0].getBoundingClientRect().top;
    shareWeiXin("magicDay");
    window.addEventListener("scroll", debounce(this.distanceShow, 300));
    window.addEventListener("scroll", debounce(this.toTop, 5));
    this.requestTjjob();

  }
  componentWillUnmount() {
    window.removeEventListener("scroll", () => {});
    window.removeEventListener("scroll", this.distanceShow);
    window.removeEventListener("scroll", this.toTop);
  }

  //上拉加载
  distanceShow = () => {
    let scrollHeight = document.documentElement.scrollHeight; //元素整个的高度
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动的高度
    let screenHeight = window.screen.height; //屏幕的高度
    let distance = scrollHeight - scrollTop - screenHeight;
    if (distance < 300) {
      //再次请求接口
      this.handAddJobItem();
    }
  };

  render() {
    let { tagList, currentIndex, jobItemList, isFlex ,successRequest,request,totalPage,currentPage,isLastPage} = this.state;
    return (
      <div className="recommend_box">
        {
          successRequest&&<div className="recommend">
          {/* <div className="recommend"> */}
          <div className="container">
            <div className="container_box">
              <div className="container_nav">
                <div
                  className={isFlex === true ? "navlist flexposition" : "navlist"}
                >
                  {tagList.length&&tagList.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className={
                          currentIndex === index
                            ? "container_li li_active"
                            : "container_li"
                        }
                        onClick={() => {
                          this.handTagActive(index);
                        }}
                      >
                        <div className="li_content">{item.tagName}</div>
                      </li>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="container_list">
              {
                jobItemList &&jobItemList.map((item, index) => {
                  return (
                    <JobItem key={index} item={item} isApply={item.isApply} request={request} />
                  );
                })
              }
              <p className="loading">
                {currentPage > totalPage|| isLastPage?"没有更多职位了...":"加载中..."}
              </p>
            </div>
          </div>
        </div>
        }
      </div>
    );
  }
}
